import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Programs from "@/pages/Programs";
import Locations from "@/pages/Locations";
import Baltimore from "@/pages/Baltimore";
import Princeton from "@/pages/Princeton";
import News from "@/pages/News";
import Events from "@/pages/Events";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Training from "@/pages/Training";
import CollegeConsulting from "@/pages/CollegeConsulting";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="programs" element={<Programs />} />
            <Route path="programs/:category" element={<Programs />} />
            <Route path="coaches" element={<Navigate to="/contact" replace />} />
            <Route path="locations" element={<Locations />} />
            <Route path="locations/:locationId" element={<Locations />} />
            <Route path="baltimore" element={<Baltimore />} />
            <Route path="princeton" element={<Princeton />} />
            <Route path="training" element={<Training />} />
            <Route path="college-consulting" element={<CollegeConsulting />} />
            <Route path="news" element={<News />} />
            <Route path="events" element={<Events />} />
            <Route path="contact" element={<Contact />} />
            <Route path="about" element={<About />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
